export const DISABILITY_PENSION_MAX_AGE = 56;
export const DISABILITY_PENSION_END_AGE = 67;
export const DISABILITY_CAPITAL_MAX_AGE = 51;
export const DISABILITY_CAPITAL_END_AGE = 62;
export const AKA_GROUP_LIFE_DISABILITY_CAPITAL_MAX_AGE = 60;
export const AKA_GROUP_LIFE_DISABILITY_CAPITAL_END_AGE = 60;
export const AKA_GROUP_LIFE_DISABILITY_INTEREST_MAX_AGE = 56;
export const AKA_GROUP_LIFE_DISABILITY_INTEREST_END_AGE = 60;
